import findIndex from 'lodash/findIndex';
import {createEventHandler} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {Observable} from 'rxjs/Observable';
import 'rxjs/observable/fromPromise';
import 'rxjs/observable/merge';
import 'rxjs/observable/of';
import 'rxjs/observable/timer';
import {buildInjector} from '../../../_libs/angular-utils';
import {MAX_VIDEO_PARTICIPANTS} from '../../../config/constants';
import {getId, getLinkId} from '../../../core-utilities/domain/ReduxUtils';
import {videoChatStartModal} from '../../redux/videoChatStartModal';
import {getChannelSelectorTarget} from '../../utils';
import {videoSessionsActions} from '../../redux/videoSessionRequests';


// Use legacy service to locally handle per-item requests, since they are allowed to occur in parallel
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'selectorsService',
]);

const SELECTED = 'selected';
const REMOVED = 'removed';

// TODO: setup start call action
export const VideoCallStartModalHOC = (config) => (state$, dispatch) => (props$) => {
  const {
    getModalState,
  } = config;

  const {
    handler: onSelectUser,
    stream: selectUser$,
  } = createEventHandler();
  const {
    handler: onRemoveSelected,
    stream: removeSelected$,
  } = createEventHandler();
  const {
    handler: onStartCall,
    stream: startCall$,
  } = createEventHandler();

  const channel$ = state$
    .map(getModalState)
    .map(state => state.channel)
    .distinctUntilChanged()
    .takeUntil(props$.last());

  const viewState$ = Observable
    .merge(
      selectUser$.map(mapSelectAction),
      removeSelected$.map(mapRemoveAction),
    )
    .withLatestFrom(channel$)
    .switchMap(([action, channel]) => {
      const {type} = action;
      switch (type) {
        case REMOVED:
          return Observable.of(action);

        case SELECTED:
          return Observable.fromPromise(dependencies.selectorsService
            .selectPersonnelRedux({
              useSimple: true,
              selected: void 0,
              exclusions: {
                nonUsers: true,
                teams: true,
              },
              ...getChannelSelectorTarget(channel),
            }))
            .map(model => ({type: SELECTED, model}))
            .catch(() => Observable.empty()); // ignore cancelled modal

        default:
          console.warn('MISSING ACTION');
          return Observable.empty();
      }
    })
    .startWith({
      selected: [],
    })
    .scan((acc, data) => ({
      ...acc,
      selected: updateSelected(acc.selected, data),
    }))
    .takeUntil(props$.last())
    .publishReplay(1)
    .refCount();

  startCall$
    .withLatestFrom(channel$, viewState$)
    .takeUntil(props$.last())
    .subscribe(([e, channel, viewState]) => {
      if (channel && channel.session) {
        dispatch(videoSessionsActions.startSession.sendRequest({
          channelId: getId(channel),
          sessionId: channel.session,
          invites: viewState.selected.map(model => getLinkId(model, 'aliasFor')),
        }));
        // dispatch(videoSessionsActions.navToVideo({
        //   channelId: channel.id,
        //   sessionId: channel.session,
        // }));
      } else {
        dispatch(videoSessionsActions.createSession.sendRequest({
          channelId: getId(channel),
          invites: viewState.selected.map(model => getLinkId(model, 'aliasFor')),
        }));
      }

      dispatch(videoChatStartModal.actions.hideModal({}));
    });

  return props$
    .combineLatest(
      viewState$,
      (props, viewState) => ({
        ...props,
        ...viewState,
        disableAddUser: viewState.selected.length >= MAX_VIDEO_PARTICIPANTS - 1,
        disableStartCall: viewState.selected.length === 0,
        onSelectUser,
        onRemoveSelected,
        onStartCall,
      }));
};

function mapSelectAction() {
  return {type: SELECTED};
}

function mapRemoveAction([e, model]) {
  return {e, model, type: REMOVED};
}

function updateSelected(prevSelected, action) {
  const {type} = action;
  switch (type) {
    case REMOVED:
      return prevSelected
        .filter(model => getId(model) !== getId(action.model));

    case SELECTED:
      if (findIndex(prevSelected, model => getId(model) === getId(action.model)) === -1) {
        return [
          ...prevSelected,
          action.model,
        ];
      }

    /* fall-through */
    default:
      return prevSelected;
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/components/VideoCallStartModal/VideoCallStartModalContainer.js